import { isDataValid, isDefined } from "../shared";

const PADDING_TOP = 25;
const PADDING_LEFT = 30;
const PADDING_RIGHT = 30;
const PADDING_BOTTOM = 30;

let _ctx = null;
let _width;
let _height;

export function draw(canvas, ctx, dataX, dataY, angle, revert) {
  if (!isDefined(canvas) || !isDefined(ctx)) {
    return;
  }
  // 清除绘制
  canvas.height = canvas.height;
  if (!isDefined(dataX) || !isDefined(dataY)) {
    return;
  }
  _ctx = ctx;
  _width = canvas.width;
  _height = canvas.height;
  let str;
  let realLen = dataY.length * 0.01;
  let yMax = Math.ceil(Math.max.apply(null, dataY));
  let yNum = parseInt(Math.ceil(yMax / 20));
  let yScale = (_height - PADDING_TOP - PADDING_BOTTOM) / yNum;
  let xConvertParam = (_width - PADDING_LEFT - PADDING_RIGHT) / realLen;
  let yConvertParam = (_height - PADDING_TOP - PADDING_BOTTOM) / yMax;
  let temp = parseInt(realLen * 5);
  let xHalfNum = parseInt((temp - (temp % 5)) / 5);
  let real = [];
  let dash = [];
  let halfLen = parseInt(dataX.length / 2);
  for (let i = 0; i < halfLen; i++) {
    // if (!revert) {
    //   let x = dataX[i] * xConvertParam
    //   let y = -dataY[i] * yConvertParam
    //   real.push({ x, y })
    //   x = dataX[i + halfLen] * xConvertParam
    //   y = -dataY[i + halfLen] * yConvertParam
    //   dash.push({ x, y })
    // } else {
    let x = dataX[i] * xConvertParam;
    let y = -dataY[i] * yConvertParam;
    dash.push({ x, y });
    x = dataX[i + halfLen] * xConvertParam;
    y = -dataY[i + halfLen] * yConvertParam;
    real.push({ x, y });
    // }
  }
  let centerX = _width / 2;
  let centerY = _height - PADDING_BOTTOM;
  _ctx.fillStyle = "#bec0cc";
  _ctx.font = "18px serif";
  _ctx.lineWidth = 1;
  _ctx.strokeStyle = "rgba(255,255,255,0.1)";

  str = "μm";
  _ctx.fillText(str, PADDING_LEFT - _ctx.measureText(str).width / 2, 13);
  str = `${angle._toFixed(0)}°`;
  _ctx.fillText(str, _width - _ctx.measureText(str).width, 18);

  _ctx.translate(centerX, _height - PADDING_BOTTOM);
  let toLeft = centerX - PADDING_LEFT;
  let toRight = centerX - PADDING_RIGHT;
  // 绘制Y轴网格 横向
  let N = yNum > 10 ? parseInt(Math.round(yNum / 10)) : 1;
  _ctx.beginPath();
  for (let i = 0; i <= yNum; i++) {
    _ctx.moveTo(-toLeft, -i * yScale);
    _ctx.lineTo(toRight, -i * yScale);
    if (i > 0) {
      if (i % N === 0) {
        str = i * 20;
        let w = _ctx.measureText(str).width;
        _ctx.fillText(str, -toLeft - w - 1, -i * yScale + 6);
      }
    }
  }
  // 绘制X轴网格 纵向
  _ctx.moveTo(-toLeft, 0);
  _ctx.lineTo(-toLeft, -yNum * yScale);

  _ctx.moveTo(toRight, 0);
  _ctx.lineTo(toRight, -yNum * yScale);
  _ctx.moveTo(0, 0);
  _ctx.lineTo(0, -yNum * yScale);

  str = "0";
  let strW = _ctx.measureText(str).width;
  _ctx.fillText(str, -strW / 2, 20);
  let tmp = -yNum * yScale;
  for (let i = 1; i <= xHalfNum; i++) {
    _ctx.moveTo(-i * 0.5 * xConvertParam, 0);
    _ctx.lineTo(-i * 0.5 * xConvertParam, tmp);
    str = (-i * 0.5)._toFixed(1);
    _ctx.fillText(str, -i * 0.5 * xConvertParam - _ctx.measureText(str).width / 2, 20);
    _ctx.moveTo(i * 0.5 * xConvertParam, 0);
    _ctx.lineTo(i * 0.5 * xConvertParam, tmp);
    str = (i * 0.5)._toFixed(1);
    _ctx.fillText(str, i * 0.5 * xConvertParam - _ctx.measureText(str).width / 2, 20);
  }
  _ctx.stroke();

  _ctx.translate(-centerX, -_height + PADDING_BOTTOM);
  if (realLen <= 0) return;

  // 绘制渐变框
  _ctx.translate(PADDING_LEFT, centerY);
  let rectWidth = xConvertParam * 0.01;
  for (let i = 0; i < dataX.length; i++) {
    let grad = _ctx.createLinearGradient(0, 0, 0, -125 * yConvertParam);
    // let colorVal = parseInt(Math.abs((255 / yMax) * dataY[i]))
    // if (isNaN(colorVal)) {
    //   continue
    // }
    if (!isDataValid(dataY[i])) continue;
    grad.addColorStop(0, `#000`);
    grad.addColorStop(1, `rgb(6,235,5)`);
    _ctx.fillStyle = grad;
    _ctx.fillRect(
      dataX[i] * xConvertParam - rectWidth / 2 - 1,
      -dataY[i] * yConvertParam,
      rectWidth + 2,
      dataY[i] * yConvertParam
    );
  }

  // 绘制曲线
  _ctx.strokeStyle = "white";
  if (revert) {
    _ctx.setLineDash([2, 4]);
  } else {
    _ctx.setLineDash([]);
  }
  drawCurve(_ctx, dash);
  if (!revert) {
    _ctx.setLineDash([2, 4]);
  } else {
    _ctx.setLineDash([]);
  }
  drawCurve(_ctx, real);

  _ctx.translate(-PADDING_LEFT, -centerY);
}

function drawCurve(ctx, arr) {
  if (!isDefined(ctx) || !Array.isArray(arr) || arr.length <= 0) {
    return;
  }
  ctx.beginPath();
  for (let i = 0; i < arr.length; i++) {
    if (i === 0) {
      ctx.moveTo(arr[i].x, arr[i].y);
    } else {
      ctx.lineTo(arr[i].x, arr[i].y);
    }
  }
  ctx.stroke();
}



// WEBPACK FOOTER //
// ./src/topography/js/ThickDrawn.js